/* jquery.youtube-background v1.0.4 | Nikola Stamatovic <@stamat> | MIT */

var tag = document.createElement('script');
tag.src = "https://www.youtube.com/player_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

(function ($) {
    $.fn.youtube_background = function(params) {
		var YOUTUBE = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
        var $this = $(this);

		var defaults = {
			'pause': false, //deprecated
			'play-button': false,
			'mute-button': false,
			'autoplay': true,
			'muted': true,
			'loop': true,
			'mobile': false,
			'load-background': true
		}

		if (!params) {
			params = defaults;
		} else {
			for (var k in defaults) {
				//load in defaults
				if (!params.hasOwnProperty(k)) {
					params[k] = defaults[k];
				}
			}
		}

		//pause deprecated
		if (params.pause) {
			params['play-button'] = params.pause;
		}

        function onVideoPlayerReady(event) {
			if (params.autoplay) {
				event.target.playVideo();
			}

            $(event.target.a).css({
                "top" : "50%",
                "left" : "50%",
                "transform": "translateX(-50%) translateY(-50%)",
                "position": "absolute"
            });

            var $root = $(event.target.a).parent();

            function onResize() {
                var h = $root.outerHeight() + 100; // since showinfo is deprecated and ignored after September 25, 2018. we add +100 to hide it in the overflow
                var w = $root.outerWidth() + 100;
                var res = 1.77777778;

                if (res > w/h) {
                    $root.find('iframe').width(h*res).height(h);
                } else {
                    $root.find('iframe').width(w).height(w/res);
                }
            }
            $(window).on('resize', onResize);
            onResize();
        }

        function onVideoStateChange(event) {
			//video loop
			if (event.data === 0 && params.loop) {
				event.target.playVideo();
			}
        }

		function build() {
			if (!window.hasOwnProperty('__ytbg_index')) {
				window.__ytbg_index = {};
			}

			//iterate elements
			for (var i = 0; i < $this.length; i++) {
                var $elem = $($this[i]);

                if ($elem.parent().hasClass('youtube-background')) {
                    continue;
                }

				var ytid = $elem.data('youtube');

				if (!ytid) {
					continue;
				}

                var pts = ytid.match(YOUTUBE);
                if (pts && pts.length) {
                    ytid = pts[1];
					YOUTUBE.lastIndex = 0; //regex needs a reset in for loops, I always forget this
                } else {
					continue;
				}

				for (var k in params) {
					var data = $elem.data('ytbg-'+k);
					if (data !== undefined && data !== null) {
						params[k] = data;
					}
				}

				//pause deprecated
				if (params.pause) {
					params['play-button'] = params.pause;
				}

                $elem.wrap('<div class="youtube-background" />');
                var $root = $elem.parent();

				//set css rules
                $root.css({
                    "height" : "100%",
                    "width" : "100%",
                    "z-index": "0",
                    "position": "absolute",
                    "overflow": "hidden",
                    "top": 0, // added by @insad
                    "left": 0,
                    "bottom": 0,
                    "right": 0,
                    "pointer-events": "none" // avoid right mouse click popup menu
                });

				if (params['load-background']) {
					$root.css({
						'background-image': 'url(https://img.youtube.com/vi/'+ytid+'/maxresdefault.jpg)',
						'background-size': 'cover',
						'background-repeat': 'no-repeat',
						'background-position': 'center'
					});
				}

				$root.parent().css({
                    "position": "relative"
                });

				//if mobile browser break
				var is_mobile = false;
				(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) is_mobile = true;})(navigator.userAgent||navigator.vendor||window.opera);

				if (is_mobile && !params.mobile) {
					continue;
				}

				if (params['play-button'] || params['mute-button']) {
					var $vbc = $('<div class="video-background-controls" />');
					$vbc.css({
						'position': 'absolute',
						'z-index': 2,
						'top': '10px',
						'right': '10px'
					});
					$root.parent().append($vbc);
				}

				//add a play toggle button
				if (params['play-button']) {
					var $btn = $('<button class="play-toggle"><i class="fa fa-pause-circle"></i></button>');

					if (!params.autoplay) {
						$btn.addClass('paused');
						$this.find('i').removeClass('fa-pause-circle').addClass('fa-play-circle');
					}

					$btn.on('click', function() {
						var $this = $(this);
						var player = $this.parent().parent().find('.youtube-background').data('yt-player');

						if ($this.hasClass('paused')) {
							$this.removeClass('paused');
							$this.find('i').addClass('fa-pause-circle').removeClass('fa-play-circle');
							if (player) {
								player.playVideo();
							}
						} else {
							$this.addClass('paused');
							$this.find('i').removeClass('fa-pause-circle').addClass('fa-play-circle');
							if (player) {
								player.pauseVideo();
							}
						}
					});
					$root.parent().find('.video-background-controls').append($btn);
				}

				if (params['mute-button']) {
					var $btn = $('<button class="mute-toggle"><i class="fa fa-volume-up"></i></button>');

					if (params.muted) {
						$btn.addClass('muted');
						$btn.find('i').addClass('fa-volume-mute').removeClass('fa-volume-up');
					}

					$btn.on('click', function() {
						var $this = $(this);
						var player = $this.parent().parent().find('.youtube-background').data('yt-player');

						if (!$this.hasClass('muted')) {
							$this.addClass('muted');
							$this.find('i').addClass('fa-volume-mute').removeClass('fa-volume-up');
							if (player) {
								player.mute();
							}
						} else {
							$this.removeClass('muted');
							$this.find('i').removeClass('fa-volume-mute').addClass('fa-volume-up');
							if (player) {
								player.unMute();
							}
						}
					});
					$root.parent().find('.video-background-controls').append($btn);
				}

				//index the instance
				function getRandomIntInclusive(min, max) {
				  min = Math.ceil(min);
				  max = Math.floor(max);
				  return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
				}

				var uid = ytid +'-'+ getRandomIntInclusive(0, 999);
				while (window.__ytbg_index.hasOwnProperty(uid)) {
					uid = ytid +'-'+ getRandomIntInclusive(0, 999);
				}

				window.__ytbg_index[uid] = {
					elem: $elem[0],
					ytid: ytid
				};
			}
		}
		build();

        window.onYouTubeIframeAPIReady = function () {
            //instance index iterate
            for (var k in window.__ytbg_index) {
                var entry = window.__ytbg_index[k];
				var $root = $(entry.elem).parent();

                ytp = new YT.Player(entry.elem, {
                    height: '1080',
                    width: '1920',
                    videoId: entry.ytid,
                    playerVars: {
                        'controls': 0,
                        'autoplay': params.autoplay ? 1 : 0,
                        'mute': params.muted ? 1 : 0,
                        'origin': window.location.origin,
                        'loop': params.loop ? 1 : 0,
                        'rel': 0,
						'ecver': 2,
                        'showinfo': 0,
                        'modestbranding': 1
                    },
                    events: {
                        'onReady': onVideoPlayerReady,
                        'onStateChange': onVideoStateChange
                    }
                });

				$root.data('yt-player', ytp);
				delete window.__ytbg_index[k];
            }
        };

        if (window.hasOwnProperty('YT') && window.YT.loaded) {
            window.onYouTubeIframeAPIReady();
        }

 		return $this;
 	};
})(jQuery);
